import deepEqual from 'fast-deep-equal/es6';

type IndexableType = { [key: string]: any };

export function findDifferentProperties<T extends IndexableType, Y extends IndexableType>(
  obj1: T,
  obj2: Y,
  path: string[] = []
): string[][] {
  let differentProperties: string[][] = [];

  Object.entries(obj1).forEach(([key, value]) => {
    const newPath = path.concat(key);
    const value1 = value;
    const value2 = obj2[key];

    if (
      value1 !== value2 &&
      ((typeof value1 !== 'object' && typeof value2 !== 'object') ||
        value1 === null ||
        value2 === null ||
        value1 === undefined ||
        value2 === undefined ||
        key === 'publicTabs')
    ) {
      differentProperties.push(newPath);
    } else if (Array.isArray(value1) && Array.isArray(value2) && !deepEqual(value1, value2)) {
      differentProperties.push(newPath);
    } else if (typeof value1 === 'object' && typeof value2 === 'object' && value1 !== null) {
      const nestedDifferentProperties = findDifferentProperties(value1, value2, newPath);
      differentProperties = differentProperties.concat(nestedDifferentProperties);
    }
  });

  return differentProperties;
}
